export default __webpack_public_path__ + "static/media/EndMillTypesImg.55a33280.jpg";